export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_PRE_PROPOSAL = 'GET_PRE_PROPOSAL';
export const GET_PRE_PROPOSAL_BY_HASH = 'GET_PRE_PROPOSAL_BY_HASH';
export const UPDATE_PRE_PROPOSAL = 'UPDATE_PRE_PROPOSAL';
export const PENDING_PRE_PROPOSAL = 'PENDING_PRE_PROPOSAL';
export const APPROVE_PRE_PROPOSAL = 'APPROVE_PRE_PROPOSAL';
